// extracted by mini-css-extract-plugin
export var back = "SlipFooter-module--back--f6441";
export var button = "SlipFooter-module--button--716c0";
export var buttons = "SlipFooter-module--buttons--83b2a";
export var clamp = "SlipFooter-module--clamp--96f2a";
export var close = "SlipFooter-module--close--ab3a1";
export var container = "SlipFooter-module--container--59fe2";
export var content = "SlipFooter-module--content--2bdf2";
export var eventName = "SlipFooter-module--eventName--47ad6";
export var exoticTitle = "SlipFooter-module--exoticTitle--1789e";
export var footer = "SlipFooter-module--footer--326fb";
export var footerInner = "SlipFooter-module--footerInner--adff4";
export var header = "SlipFooter-module--header--9180d";
export var hidden = "SlipFooter-module--hidden--79ef6";
export var icon = "SlipFooter-module--icon--02d87";
export var iconButton = "SlipFooter-module--iconButton--42446";
export var info = "SlipFooter-module--info--e4a6e";
export var isReviewing = "SlipFooter-module--isReviewing--32a3a";
export var label = "SlipFooter-module--label--d9b1e";
export var largeFooter = "SlipFooter-module--largeFooter--6f553";
export var marketName = "SlipFooter-module--marketName--8b9ff";
export var outcomeIcon = "SlipFooter-module--outcomeIcon--5927e";
export var panel = "SlipFooter-module--panel--02d29";
export var reuseBetsButton = "SlipFooter-module--reuseBetsButton--ac237";
export var right = "SlipFooter-module--right--8f5ba";
export var scrollArea = "SlipFooter-module--scrollArea--d3ec6";
export var selectionName = "SlipFooter-module--selectionName--c8e11";
export var skeletonButton = "SlipFooter-module--skeletonButton--00052";
export var skeletonIconButton = "SlipFooter-module--skeletonIconButton--74cb4";
export var small = "SlipFooter-module--small--3e7c1";
export var smallFooter = "SlipFooter-module--smallFooter--db656";
export var tab = "SlipFooter-module--tab--703d6";
export var tabList = "SlipFooter-module--tabList--1bf58";
export var tabListContainer = "SlipFooter-module--tabListContainer--59ad3";
export var tabs = "SlipFooter-module--tabs--42eb0";
export var title = "SlipFooter-module--title--0fc71";
export var trash = "SlipFooter-module--trash--f2382";
export var value = "SlipFooter-module--value--21939";